<div class="integration-center">
   <div class="flex-align-center" style="gap: 5rem;">
       <div>
           <img src="../../../../assets/svg/xero.svg" class="w-70px" alt="">
       </div>
       <div class="text-center">
           <h5>Connecting to Xero ....</h5>
           <p>This window will close in&nbsp;{{time}}&nbsp;seconds...</p>
       </div>
       <div>
           <img src="../../../../assets/svg/table/Fieldex_Bg.svg" class="w-70px" alt="">
       </div>
   </div>
</div>